// mds-dojo — dijit/form/_numberRegexp — FAITHFUL port of the regexp-building half of
// references/dojo/number.js (number.regexp / number._parseInfo / number._realNumberRegexp /
// number._integerRegexp / number._numberPatternRE).
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!! FLAG — WHY THIS FILE EXISTS (adaptation, not a stub):
// !!! The canonical mds `dojo/number` is a slim en-only implementation that provides only
// !!! format()/parse()/round() and does NOT export regexp()/_realNumberRegexp(), which
// !!! dijit/form/NumberTextBox requires. Editing dojo/number.ts is out of scope for this
// !!! task (must not touch files outside dijit/form/). So the missing generators are ported
// !!! here FAITHFULLY from the real dojo/number.js. The ONLY behavioral change vs. real dojo
// !!! is locale: real dojo pulls the CLDR "number" bundle via dojo/i18n; the mds number
// !!! stack has no i18n loader, so the en/root CLDR number bundle is inlined below and the
// !!! `locale` option is ignored — i.e. always en-style grouping (',' group, '.' decimal),
// !!! consistent with the slim en-only dojo/number.format/parse already used by mds.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
import dregexp from '../../dojo/regexp'; // buildGroupRE, escapeString

// Inlined dojo/cldr/nls/number en/root bundle (locale-independent here).
var numberBundle: any = {
	decimalFormat: "#,##0.###",
	scientificFormat: "#E0",
	percentFormat: "#,##0%",
	currencyFormat: "¤#,##0.00;(¤#,##0.00)",
	group: ",",
	decimal: ".",
	currencyGroup: undefined,
	currencyDecimal: undefined
};

var number: any = {};

number._numberPatternRE = /[#0,]*[#0](?:\.0*#*)?/; // not precise, but good enough

number.regexp = function (/*number.__RegexpOptions?*/ options: any) {
	// summary:
	//		Builds the regular needed to parse a number
	// description:
	//		Returns regular expression with positive and negative match, group
	//		and decimal separators
	return number._parseInfo(options).regexp; // String
};

number._parseInfo = function (/*Object?*/ options: any) {
	options = options || {};
	var bundle = numberBundle,
		pattern = options.pattern || bundle[(options.type || "decimal") + "Format"],
		group = bundle.group,
		decimal = bundle.decimal,
		factor = 1;

	var isCurrency;
	if (pattern.indexOf('%') != -1) {
		factor /= 100;
	} else if (pattern.indexOf('‰') != -1) {
		factor /= 1000; // per mille
	} else {
		isCurrency = pattern.indexOf('¤') != -1;
		if (isCurrency) {
			group = bundle.currencyGroup || group;
			decimal = bundle.currencyDecimal || decimal;
		}
	}

	//TODO: handle quoted escapes
	var patternList = pattern.split(';');
	if (patternList.length == 1) {
		patternList.push("-" + patternList[0]);
	}

	var re = dregexp.buildGroupRE(patternList, function (pattern: any) {
		pattern = "(?:" + dregexp.escapeString(pattern, '.') + ")";
		return pattern.replace(number._numberPatternRE, function (format: any) {
			var flags: any = {
				signed: false,
				separator: options.strict ? group : [group, ""],
				fractional: options.fractional,
				decimal: decimal,
				exponent: false
			},

				parts = format.split('.'),
				places = options.places;

			// special condition for percent (factor != 1)
			// allow decimal places even if not specified in pattern
			if (parts.length == 1 && factor != 1) {
				parts[1] = "###";
			}
			if (parts.length == 1 || places === 0) {
				flags.fractional = false;
			} else {
				if (places === undefined) { places = options.pattern ? parts[1].lastIndexOf('0') + 1 : Infinity; }
				if (places && options.fractional == undefined) { flags.fractional = true; } // required fractional, unless otherwise specified
				if (!options.places && (places < parts[1].length)) { places += "," + parts[1].length; }
				flags.places = places;
			}
			var groups = parts[0].split(',');
			if (groups.length > 1) {
				flags.groupSize = groups.pop().length;
				if (groups.length > 1) {
					flags.groupSize2 = groups.pop().length;
				}
			}
			return "(" + number._realNumberRegexp(flags) + ")";
		});
	}, true);

	if (isCurrency) {
		// substitute the currency symbol for the placeholder in the pattern
		re = re.replace(/([\s\xa0 ]*)(¤{1,3})([\s\xa0 ]*)/g, function (match: any, before: any, target: any, after: any) {
			var prop = ["symbol", "currency", "displayName"][target.length - 1],
				symbol = dregexp.escapeString(options[prop] || options.currency || "");

			// if there is no symbol there is no need to take white-spaces into account.
			if (!symbol) {
				return "";
			}

			before = before ? "[\\s\\xa0\\u202f]" : "";
			after = after ? "[\\s\\xa0\\u202f]" : "";
			if (!options.strict) {
				if (before) { before += "*"; }
				if (after) { after += "*"; }
				return "(?:" + before + symbol + after + ")?";
			}
			return before + symbol + after;
		});
	}

	//TODO: substitute localized sign/percent/permille/etc.?

	// normalize whitespace and return
	return { regexp: re.replace(/[\xa0  ]/g, "[\\s\\xa0\\u202f]"), group: group, decimal: decimal, factor: factor }; // Object
};

number._realNumberRegexp = function (/*__RealNumberRegexpFlags?*/ flags: any) {
	// summary:
	//		Builds a regular expression to match a real number in exponential
	//		notation

	// assign default values to missing parameters
	flags = flags || {};
	//TODO: use mixin instead?
	if (!("places" in flags)) { flags.places = Infinity; }
	if (typeof flags.decimal != "string") { flags.decimal = "."; }
	if (!("fractional" in flags) || /^0/.test(flags.places)) { flags.fractional = [true, false]; }
	if (!("exponent" in flags)) { flags.exponent = [true, false]; }
	if (!("eSigned" in flags)) { flags.eSigned = [true, false]; }

	var integerRE = number._integerRegexp(flags),
		decimalRE = dregexp.buildGroupRE(flags.fractional,
			function (q: any) {
				var re = "";
				if (q && (flags.places !== 0)) {
					re = "\\" + flags.decimal;
					if (flags.places == Infinity) {
						re = "(?:" + re + "\\d+)?";
					} else {
						re += "\\d{" + flags.places + "}";
					}
				}
				return re;
			},
			true
		);

	var exponentRE = dregexp.buildGroupRE(flags.exponent,
		function (q: any) {
			if (q) { return "([eE]" + number._integerRegexp({ signed: flags.eSigned }) + ")"; }
			return "";
		}
	);

	var realRE = integerRE + decimalRE;
	// allow for decimals without integers, e.g. .25
	if (decimalRE) { realRE = "(?:(?:" + realRE + ")|(?:" + decimalRE + "))"; }
	return realRE + exponentRE; // String
};

number._integerRegexp = function (/*number.__IntegerRegexpFlags?*/ flags: any) {
	// summary:
	//		Builds a regular expression that matches an integer

	// assign default values to missing parameters
	flags = flags || {};
	if (!("signed" in flags)) { flags.signed = [true, false]; }
	if (!("separator" in flags)) {
		flags.separator = "";
	} else if (!("groupSize" in flags)) {
		flags.groupSize = 3;
	}

	var signRE = dregexp.buildGroupRE(flags.signed,
		function (q: any) { return q ? "[-+]" : ""; },
		true
	);

	var numberRE = dregexp.buildGroupRE(flags.separator,
		function (sep: any) {
			if (!sep) {
				return "(?:\\d+)";
			}

			sep = dregexp.escapeString(sep);
			if (sep == " ") { sep = "\\s"; }
			else if (sep == "\xa0") { sep = "\\s\\xa0"; }
			else if (sep == " ") { sep = "\\s\\u202f"; }

			var grp = flags.groupSize, grp2 = flags.groupSize2;
			//TODO: should we continue to enforce that numbers with separators begin with 1-9?  See #6933
			if (grp2) {
				var grp2RE = "(?:0|[1-9]\\d{0," + (grp2 - 1) + "}(?:[" + sep + "]\\d{" + grp2 + "})*[" + sep + "]\\d{" + grp + "})";
				return ((grp - grp2) > 0) ? "(?:" + grp2RE + "|(?:0|[1-9]\\d{0," + (grp - 1) + "}))" : grp2RE;
			}
			return "(?:0|[1-9]\\d{0," + (grp - 1) + "}(?:[" + sep + "]\\d{" + grp + "})*)";
		},
		true
	);

	return signRE + numberRE; // String
};

export default number;
